import { getOfficesFetchPath, getRestApiClient } from 'config/api';
import {
  LOAD_OFFICES,
  LOAD_OFFICES_SUCCESS,
  LOAD_OFFICES_FAIL
} from './constants';

const loadInit = () => ({
  type: LOAD_OFFICES
});

const loadSuccess = (result) => ({
  type: LOAD_OFFICES_SUCCESS,
  result
});

const loadFail = () => ({
  type: LOAD_OFFICES_FAIL
});

export const load = ({
  url = getOfficesFetchPath(),
  client = getRestApiClient()
} = {}) => async (dispatch) => {
  dispatch(loadInit());
  try {
    const result = await client.get(url);
    dispatch(loadSuccess(result));
  } catch (e) {
    dispatch(loadFail());
  }
};
